import { envPrefix } from '../FirebaseContext';

export const defaultIndexName = `${envPrefix}ARTISTPAGES`;
export const alphabeticalIndexName = `${envPrefix}ARTISTPAGES`;
export const popularityIndexName = `${envPrefix}ARTISTPAGES_songCount`;
export const ageIndexName = `${envPrefix}ARTISTPAGES_age`;
export const featuredIndexName = `${envPrefix}ARTISTPAGES_featured`;
export const ratingsIndexName = `${envPrefix}ARTISTPAGES_ratings`;
